import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Icon from "../components/Icon";
import ManifestStrip from "../components/ManifestStrip";
import {
  company,
  overview,
  vision,
  services,
  whyChooseUs,
  industries,
} from "../data/content";

export default function Home() {
  return (
    <>
      <Seo path="/" />

      <section className="hero">
        <div className="hero__bg">
          <img src="/images/port-aerial-crane.jpg" alt="Aerial view of container ship being loaded at port" />
        </div>
        <div className="hero__inner">
          <span className="eyebrow hero__eyebrow">{company.legalName}</span>
          <h1>
            Strategic Freight &amp; <em>Supply Chain</em> Partner
          </h1>
          <p className="hero__sub">
            We move goods, projects, and opportunities across borders with confidence —
            connecting Indonesian businesses to global markets through reliable,
            end-to-end logistics.
          </p>
          <div className="hero__actions">
            <Link to="/contact" className="btn btn-primary">
              Get a Quote <Icon name="arrowRight" size={18} />
            </Link>
            <Link to="/services" className="btn btn-ghost">
              Explore Services
            </Link>
          </div>
          <div className="hero__slogan">&ldquo;{company.slogan}&rdquo;</div>
        </div>
      </section>

      <ManifestStrip />

      <section className="section section--alt">
        <div className="container overview">
          <div className="overview__media photo-panel photo-panel--diagonal">
            <img src="/images/container-stack-closeup.jpg" alt="Close-up of stacked shipping containers" />
          </div>
          <div className="overview__body">
            <span className="eyebrow">Company Overview</span>
            <h2 style={{ marginTop: 10, fontSize: "clamp(1.8rem,3.4vw,2.5rem)" }}>
              Trusted across domestic &amp; international markets
            </h2>
            <div style={{ marginTop: 22 }}>
              {overview.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">What We Do</span>
            <h2>Our Services</h2>
            <p>
              A single logistics partner capable of managing every stage of your supply
              chain — from origin to final mile.
            </p>
          </div>
          <div className="services-grid">
            {services.map((s) => (
              <article className="service-card" key={s.code}>
                <div className="service-card__image">
                  <img src={s.image} alt={s.title} />
                </div>
                <div className="service-card__body">
                  <div className="service-card__top">
                    <div className="service-card__icon">
                      <Icon name={s.icon} />
                    </div>
                    <span className="service-card__code">{s.code}</span>
                  </div>
                  <h3>{s.title}</h3>
                  <p>{s.description}</p>
                </div>
              </article>
            ))}
          </div>
          <div style={{ marginTop: 36, textAlign: "center" }}>
            <Link to="/services" className="btn btn-dark">
              View All Services <Icon name="arrowRight" size={18} />
            </Link>
          </div>
        </div>
      </section>

      <section className="section section--dark">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">Our Vision</span>
            <h2>{vision}</h2>
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">Why Bumi Logistics</span>
            <h2>Why Choose Us?</h2>
            <p>Five reasons clients trust us as their strategic logistics partner.</p>
          </div>
          <div className="why-grid">
            {whyChooseUs.map((w) => (
              <div className="why-card" key={w.number}>
                <span className="why-card__num">{w.number}</span>
                <h3>{w.title}</h3>
                <p>{w.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">Who We Serve</span>
            <h2>Industries</h2>
          </div>
          <div className="industries-grid">
            {industries.slice(0, 10).map((ind) => (
              <div className="industry-card" key={ind.title}>
                <div className="industry-card__icon">
                  <Icon name={ind.icon} size={20} />
                </div>
                <h3 style={{ fontSize: "1rem" }}>{ind.title}</h3>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 30, textAlign: "center" }}>
            <Link to="/industries" className="btn btn-ghost" style={{ color: "var(--ink-900)", borderColor: "var(--line)" }}>
              See All Industries <Icon name="arrowRight" size={18} />
            </Link>
          </div>
        </div>
      </section>

      <section className="section section--tight">
        <div className="container">
          <div className="cta-banner">
            <h2>Ready to Connect Your Business Across Nations?</h2>
            <Link to="/contact" className="btn btn-dark">
              Talk to Our Team <Icon name="arrowRight" size={18} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
